import { useAppDisplayModeContext } from '@archipro-design/aria';
import { VideoPlayer, useStyles } from '@archipro-design/aria';
import { useEffect } from 'react';
import { useBoolean } from 'ahooks';
import type { VideoColumnProps } from '@modules/page-builder/types';
import * as S from './SingleVideoModule.style';
import { getVideoCoverImage } from '@modules/page-builder/util/get-video-cover-image';
import { useTracker } from '@archipro-website/tracker';
import ImageCaptionArticle from '../../common/image-caption/ImageCaptionArticle';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail/detail-modules/DetailModules.style';

interface SingleVideoModuleProps {
    column: VideoColumnProps;
    shouldAutoPlayVideo?: boolean;
    playIconSizeDesktop?: number;
    isCoverGrayscale?: boolean;
}

const SingleVideoModule = ({
    column,
    playIconSizeDesktop = 130,
    shouldAutoPlayVideo = false,
    isCoverGrayscale = false,
}: SingleVideoModuleProps) => {
    const { css } = useStyles({
        dimension: column.dimension,
    });
    const { mobile } = useAppDisplayModeContext();
    const tracker = useTracker();

    const videoURL = column.video?.videoURL || '';
    const caption = column.video?.caption;
    const coverImage = getVideoCoverImage(column, mobile);

    const [isPlaying, playingAction] = useBoolean();
    useEffect(() => {
        if (shouldAutoPlayVideo) {
            playingAction.setTrue();
        }
    }, [shouldAutoPlayVideo, playingAction]);

    return (
        <div className={css(S.SingleVideoModule, ImageModuleExtraSpacing)}>
            {videoURL && (
                <div className={css(S.AspectRatioBox)}>
                    <VideoPlayer
                        src={videoURL}
                        coverImage={coverImage}
                        muted={false}
                        playing={isPlaying}
                        controls={true}
                        variables={{
                            playIconSizeDesktop: playIconSizeDesktop,
                            playIconSizeMobile: 62,
                            coverImagePosition: 'absolute',
                        }}
                        trackPlayEvent={() => {
                            tracker.log('Video', {
                                url: new URL(window.location.href),
                                data: {
                                    ExtraData: column.video?.id ?? 0, // VideoID
                                },
                            });
                        }}
                        alt={`${column.video?.title} video`}
                        isCoverGrayscale={isCoverGrayscale}
                    />
                </div>
            )}
            {caption && (
                <div className={css(S.CaptionVideo)}>
                    <ImageCaptionArticle text={caption} />
                </div>
            )}
        </div>
    );
};

export default SingleVideoModule;
